import { axiosApiClient } from "..";
import { handleError } from "../../utils/errors";

const BASE_URL = "/orders";

class OrdersService {
  createOrder = async (requestData) => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/`, requestData);
      if (response.status !== 201) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while creating order.");
    }
  };

  updateOrderStatus = async ({ id, status }) => {
    try {
      const response = await axiosApiClient.put(`${BASE_URL}/${id}/status`, {
        status,
      });
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while updating order status.");
    }
  };

  getOrders = async (requestData = {}) => {
    try {
      const { page = 1, limit = 12, sortByStatus = false } = requestData;
      const response = await axiosApiClient.get(`${BASE_URL}/`, {
        params: {
          page,
          limit,
          sortByStatus,
        },
      });
      if (response.status !== 200) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while fetching orders.");
    }
  };

  getOrderStats = async () => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/stats`);
      if (response.status !== 200) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while fetching order stats.");
    }
  };

  deleteOrder = async (id) => {
    try {
      const response = await axiosApiClient.delete(`${BASE_URL}/${id}`);
      if (response.status !== 200) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while deleting order.");
    }
  };
}
const ordersService = new OrdersService();

export default ordersService;
